// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrafficconfigAwsEndpointConnection } from './TrafficconfigAwsEndpointConnection';
import {
  TrafficconfigAwsEndpointConnectionFromJSON,
  TrafficconfigAwsEndpointConnectionFromJSONTyped,
  TrafficconfigAwsEndpointConnectionToJSON,
  TrafficconfigAwsEndpointConnectionToJSONTyped,
} from './TrafficconfigAwsEndpointConnection';

/**
 *
 * @export
 * @interface TrafficconfigAwsStatus
 */
export interface TrafficconfigAwsStatus {
  /**
   *
   * @type {Array<TrafficconfigAwsEndpointConnection>}
   * @memberof TrafficconfigAwsStatus
   */
  endpointConnections?: Array<TrafficconfigAwsEndpointConnection>;
  /**
   *
   * @type {string}
   * @memberof TrafficconfigAwsStatus
   */
  endpointServiceName?: string;
}

/**
 * Check if a given object implements the TrafficconfigAwsStatus interface.
 */
export function instanceOfTrafficconfigAwsStatus(
  value: object,
): value is TrafficconfigAwsStatus {
  return true;
}

export function TrafficconfigAwsStatusFromJSON(
  json: any,
): TrafficconfigAwsStatus {
  return TrafficconfigAwsStatusFromJSONTyped(json, false);
}

export function TrafficconfigAwsStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigAwsStatus {
  if (json == null) {
    return json;
  }
  return {
    endpointConnections:
      json['endpoint_connections'] == null
        ? undefined
        : (json['endpoint_connections'] as Array<any>).map(
            TrafficconfigAwsEndpointConnectionFromJSON,
          ),
    endpointServiceName:
      json['endpoint_service_name'] == null
        ? undefined
        : json['endpoint_service_name'],
  };
}

export function TrafficconfigAwsStatusToJSON(
  json: any,
): TrafficconfigAwsStatus {
  return TrafficconfigAwsStatusToJSONTyped(json, false);
}

export function TrafficconfigAwsStatusToJSONTyped(
  value?: TrafficconfigAwsStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endpoint_connections:
      value['endpointConnections'] == null
        ? undefined
        : (value['endpointConnections'] as Array<any>).map(
            TrafficconfigAwsEndpointConnectionToJSON,
          ),
    endpoint_service_name: value['endpointServiceName'],
  };
}
